/**
 * Entry point for useOmnibarEligibility hook
 *
 * This hook determines OmniBar eligibility and configuration based on Statsig experiments.
 * It checks both `cc_engagement_omnibar` and `cc_engagement_omnibar_smb` experiments
 * and returns the appropriate cohort and configuration.
 */
export {
	useOmnibarEligibility,
	type OmnibarEligibilityResult,
} from '../src/hooks/useOmnibarEligibility.ts';
